<template>
  <div :class="{ expandable: true, expanded: mutableExpanded }">
    <slot :toggle="toggle" :expanded="mutableExpanded"></slot>
    <template v-if="mutableExpanded">
      <slot name="body" :toggle="toggle" :expanded="mutableExpanded"></slot>
    </template>
  </div>
  <slot name="readmore" :toggle="toggle" :expanded="mutableExpanded"></slot>
</template>

<script setup>
import { ref, watchEffect, defineProps, defineEmits } from 'vue';

// Define props
const props = defineProps({
  expanded: { type: Boolean, default: false },
});

// Define emits
const emit = defineEmits(['update:expanded']);

// Reactive state for expansion
const mutableExpanded = ref(props.expanded);

// Sync mutableExpanded when `expanded` prop changes
watchEffect(() => {
  mutableExpanded.value = props.expanded;
});

// Toggle function
const toggle = (expanded = null) => {
  mutableExpanded.value = expanded !== null ? expanded : !mutableExpanded.value;
  emit('update:expanded', mutableExpanded.value);
};
</script>
